import { getDateTime } from "../../services/CheckMeProBlePackages";
var PACKAGESIZE = 11;
export function parsePressureItem(bytes, checkMeProUser) {
    var start = 0;
    var returnList = new Array();
    for (var k = 0; k < bytes.length - 8; k++) {
        if (start + PACKAGESIZE >= bytes.length)
            break;
        var user = {};
        returnList.push(user);
        start = k * PACKAGESIZE;
        user.date = getDateTime(bytes, start);
        user.sys = (bytes[start + 7] & 0xff) + ((bytes[start + 8] & 0xff) << 8);
        user.dia = bytes[start + 9];
        user.pr = bytes[start + 10];
        user.user = checkMeProUser;
    }
    return returnList;
}
